export default __webpack_public_path__ + "static/media/ads-kbl-01.3d275684.gif";